import React, { useCallback } from 'react';

// Relocated verbatim from EcommerceWebsite.jsx — memoized to avoid re-render
// churn across the large checkout forms.
const OptimizedInput = React.memo(({ type = 'text', value, onChange, placeholder, className, error }) => {
  const handleChange = useCallback((e) => {
    onChange(e.target.value);
  }, [onChange]);

  return (
    <input
      type={type}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
    />
  );
});

export default OptimizedInput;
